import { LabMDM } from "../masterdata/models/lab";

export  class RedoProcessingRequest { 
    redoInitiatedBy:  string;
    containerBarcode:  string;
    quadrant: string;
    lab: LabMDM;
    
} 

